import React, {Component} from "react"
import "swiper/swiper.min.css"
import "swiper/components/pagination/pagination.min.css"
import "./BannerMp.scss"
import {Swiper, SwiperSlide} from "swiper/react"
import SwiperCore, {Pagination, Autoplay} from 'swiper';

SwiperCore.use([Pagination, Autoplay]);
export default class BannerMp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bannerList: [],
        };
    }

    componentDidMount() {
        this.$axios.apiList.getHomeData({})
            .then(res => {
                this.setState({
                    bannerList: res.data.banners
                })
            })
            .catch(error => {

            })
    }

    render() {
        let {bannerList} = this.state;
        return (
            <div className="banner">
                <Swiper
                    initialSlide={0}   //初始化时的索引位置
                    speed={1000} //页面切换速度，slider自动滑动开始到结束的时间（单位ms）
                    loop={true} //是否形成环路
                    observer={true} //修改swiper自己或子元素时，自动初始化swiper
                    observeParents={true} //修改swiper的父元素时，自动初始化swiper
                    //自动滚屏
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false
                    }}
                    pagination={{clickable: true}}
                >
                    {bannerList.map((item, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <img src={item} alt=""/>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        )
    }
}
